import { gql } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { useDisabledAllInviteKeysMutation } from "src/gql/codegen/graphql";
import { Session } from "src/utils/users/types";

export function useRevokeAllInviteLinks() {
  const [callDisabledAllInviteKeysMutation, revokeAllInviteLinksResult] =
    useDisabledAllInviteKeysMutation();

  function revokeAllInviteLinks(
    teamId: number,
    session: Session
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      callDisabledAllInviteKeysMutation({
        context: { session },
        variables: {
          team_id: teamId,
        },
      }).then(
        () => {
          resolve();
        },
        (error) => {
          reject();
          Sentry.captureException(
            `Error when revoking keys for team ${teamId}: ${error}`
          );
        }
      );
    });
  }

  return [revokeAllInviteLinks, revokeAllInviteLinksResult] as const;
}

gql`
  mutation DisabledAllInviteKeys($team_id: Int!) {
    disable_all_invite_keys(team_id: $team_id) {
      ok
    }
  }
`;
